import React from 'react';

interface ChipsButtonProps {
    icon?: any;
    label: string;
    onClick?: () => void;
    onIconClick?: () => void;
    color?: string;
}

const ChipsButton: React.FC<ChipsButtonProps> = (props) => {
    return (
        <div className='d-flex justify-content-around chips-button' color={props.color} onClick={props.onClick}>
            <span className='chips-button-text'>{props.label}</span>
            <div onClick={props.onIconClick}>
                {props.icon}
            </div>
        </div>
    )
}

export default ChipsButton;